import { createCRUDConstants } from "../../../utils/redux.utils";

export const namespace = "DOMAINS"
export const domainConstants = createCRUDConstants(namespace);
